module.exports = __webpack_public_path__ + "static/img_2386-3f4b73063bb23bc87f97e8f8eaf61529.webp";